// eslint-disable-next-line
import { GetOpenedAlertByCourse } from '@/api/index';
import { Mixin } from 'gw-js-lib';

export default {
  namespaced: true,

  state() {
    return ({
      alerts: [],
      loading: {
        alerts: false,
      },
    });
  },


  getters: {},


  mutations: {

    setAlerts(state, alerts) {
      state.alerts = alerts;
      setTimeout(()=> { Mixin.methods.G_triggerResizeEven();}, 10);
    },
    setLoading(state, loading) {
      state.loading = {...state.loading, ...loading};
    },

  },


  actions: {

    async apiGetOpenedAlertByCourse({ commit, state }) {
      if ( Mixin.methods.G_isEmptyArr(state.alerts) ) {
        commit('setLoading', {alerts: true});
      }
      await GetOpenedAlertByCourse().then(async (res) => {
        commit('setAlerts', res.alerts ? res.alerts : []);
      }).finally(() => {
        commit('setLoading', {alerts: false});
      });
    },

  },

};
